import { UsernameSchema as r, UserIdSchema as m } from "@hprofits/shared";
import { z as e } from "zod";
const o = e.object({
  id: m,
  firstName: e.string(),
  lastName: e.string(),
  email: r
}).readonly();
export {
  o as OwnerSchema
};
//# sourceMappingURL=owner.js.map
